import { isDevMode } from '@angular/core';
import { withDevtools as toolkitDevtools, withDevToolsStub } from '@ngrx-toolkit/core';

export { updateState as patchState, updateState } from '@ngrx-toolkit/core';
export * from './call-state.feature';
export * from './data-service-feature';
export * from './state-slice-feature';
export const withDevtools = isDevMode() ? toolkitDevtools : withDevToolsStub;
